/** @format */

import { RootState } from "../store/store";

export const selectUserFirstName = (state: RootState) =>
	state.user.userData?.firstName;

export const selectUserLastName = (state: RootState) =>
	state.user.userData?.lastName;

export const selectIsAuthenticated = (state: RootState) =>
	state.user.isAuthenticated;

export const selectCurrentUser = (state: RootState) => state.user.userData;

export const selectUserAddRequests = (state: RootState) =>
	state.user.userData?.pendingAddRequests;

export const signInLoad = (state: RootState) => state.user.isLoading;

export const signUpLoad = (state: RootState) => state.user.isLoading;

export const selectUserIsLoading = (state: RootState) => state.user.isLoading;

export const selectSearchUserResult = (state: RootState) =>
	state.user.searchUserData;

export const userSelectorLoading = (state: RootState) => state.user.isLoading;

export const selectIsLoading = (state: RootState) => state.user.isLoading;

export const selectIsError = (state: RootState) => state.user.error;

export const selectAllCirclesOfMember = (state: RootState) =>
	state.user.userCircles;

export const selectUserMap = (state: RootState) => state.user.userMap;

export const selectUserRating = (state: RootState) => state.user.userRating;

export const selectAllJoinRequestsOfUser = (state: RootState) =>
	state.user.userJoinRequests;

export const selectUserStats = (state: RootState) =>
	state.user.userFinancialSummary;

export const selectAllUsersAsAdmin = (state: RootState) => state.user.allUsers;

export const selectAllUsersLoading = (state: RootState) => state.user.isLoading;

export const selectAllUsersError = (state: RootState) => state.user.error;

// ==================== Auto-Draft Admin Selectors ====================

export const selectAutoDraftUsers = (state: RootState) =>
	state.user.autoDraftUsers;

export const selectAutoDraftUserDetail = (state: RootState) =>
	state.user.autoDraftUserDetail;

export const selectAutoDraftSummary = (state: RootState) =>
	state.user.autoDraftSummary;

export const selectAutoDraftLoading = (state: RootState) =>
	state.user.autoDraftLoading;

export const selectAutoDraftError = (state: RootState) =>
	state.user.autoDraftError;

// ==================== Auto-Draft Results Selectors ====================

export const selectAutoDraftResults = (state: RootState) =>
	state.user.autoDraftResults;

export const selectAutoDraftResultsSummary = (state: RootState) =>
	state.user.autoDraftResults?.summary;

export const selectAutoDraftResultsAttempts = (state: RootState) =>
	state.user.autoDraftResults?.attempts;

export const selectAutoDraftResultsDate = (state: RootState) =>
	state.user.autoDraftResults?.date;

export const selectAutoDraftResultsTimezone = (state: RootState) =>
	state.user.autoDraftResults?.timezone;

export const selectAutoDraftFailed = (state: RootState) =>
	state.user.autoDraftFailed;

export const selectAutoDraftFailedAttempts = (state: RootState) =>
	state.user.autoDraftFailed?.attempts;

export const selectAutoDraftFailedPagination = (state: RootState) =>
	state.user.autoDraftFailed?.pagination;

export const selectAutoDraftFailureAnalysis = (state: RootState) =>
	state.user.autoDraftFailed?.failureAnalysis;

export const selectAutoDraftRetries = (state: RootState) =>
	state.user.autoDraftRetries;

export const selectAutoDraftRetryAttempts = (state: RootState) =>
	state.user.autoDraftRetries?.attempts;

export const selectAutoDraftRetryPagination = (state: RootState) =>
	state.user.autoDraftRetries?.pagination;

export const selectAutoDraftUpcomingRetries = (state: RootState) =>
	state.user.autoDraftRetries?.upcomingRetries;

export const selectAutoDraftAttemptDetail = (state: RootState) =>
	state.user.autoDraftAttemptDetail;

export const selectAutoDraftResultsLoading = (state: RootState) =>
	state.user.autoDraftResultsLoading;

export const selectAutoDraftResultsError = (state: RootState) =>
	state.user.autoDraftResultsError;
